var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0019 4.12311L3.65235 10.4727C2.1875 11.9375 2.1875 14.3125 3.65235 15.7773V15.7773C5.11719 17.2422 7.49218 17.2422 8.95703 15.7773L16.3457 8.38867C17.4967 7.23772 17.4967 5.37166 16.3457 4.2207V4.2207C15.1948 3.06975 13.3287 3.06975 12.1777 4.2207L5.67318 10.7253C4.83612 11.5623 4.83612 12.9195 5.67318 13.7565V13.7565C6.51023 14.5936 7.86737 14.5936 8.70443 13.7565L14.1699 8.29107",
    stroke: "#9BAEBC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/IconAttachment.9ff690d40946f5c56203e96d29255e77.svg";
export { ForwardRef as ReactComponent };